import React from "react";
import Link from "next/link";
import {
	AppBar,
	AppBarProps,
	Box,
	Breakpoint,
	Container,
	ContainerProps,
	Stack,
	Toolbar,
	ToolbarProps,
	useTheme,
} from "@mui/material";
import { useResponsive } from "@onair/minimal-ui/hooks/use-responsive";
import { useScrollOffSetTop } from "@onair/minimal-ui/hooks/use-scroll-offset-top";
import { Logo } from "@onair/minimal-ui/logo";
import HeaderRight from "./RightArea";
import { MenuButton } from "@/components/layouts/main-layout/menu-button";

export type HeaderPropTypes = AppBarProps & {
	layoutQuery?: Breakpoint;
	disableOffset?: boolean;
	disableElevation?: boolean;
	slots?: {
		button?: React.ReactNode;
		leftArea?: React.ReactNode;
		leftAreaEnd?: React.ReactNode;
		leftAreaStart?: React.ReactNode;
		rightArea?: React.ReactNode;
		rightAreaEnd?: React.ReactNode;
		rightAreaStart?: React.ReactNode;
		topArea?: React.ReactNode;
		centerArea?: React.ReactNode;
		bottomArea?: React.ReactNode;
	};
	slotProps?: {
		toolbar?: ToolbarProps;
		container?: ContainerProps;
	};
};

const Header: React.FC<HeaderPropTypes> = (props) => {
	const {
		sx,
		slots,
		slotProps,
		disableOffset,
		disableElevation,
		layoutQuery = "md",
		...other
	} = props;
	const theme = useTheme();
	const smDown = useResponsive("down", "sm");

	const { offsetTop } = useScrollOffSetTop();

	const toolbarStyles = {
		default: {
			minHeight: "auto",
			height: "var(--layout-header-mobile-height)",
			transition: theme.transitions.create(["height", "background-color"], {
				easing: theme.transitions.easing.easeInOut,
				duration: theme.transitions.duration.shorter,
			}),
			[theme.breakpoints.up("sm")]: {
				minHeight: "auto",
			},
			[theme.breakpoints.up(layoutQuery)]: {
				height: "var(--layout-header-desktop-height)",
			},
		},
	};

	return (
		<AppBar
			position="sticky"
			className="layout__header !bg-white"
			sx={{
				zIndex: "var(--layout-header-zIndex)",
				borderBottom: "1px solid rgba(145, 158, 171, 0.2)",
				backgroundColor: "white !important",
				...sx,
			}}
			{...other}
			color="default"
		>
			{slots?.topArea}
			<Toolbar
				disableGutters
				{...slotProps?.toolbar}
				sx={{
					...toolbarStyles.default,
					...(!disableOffset && offsetTop && toolbarStyles.default),
					...slotProps?.toolbar?.sx,
				}}
			>
				<Container
					maxWidth={false}
					{...slotProps?.container}
					sx={{
						...slotProps?.container?.sx,
					}}
				>
					<Stack
						direction="row"
						alignItems="center"
						justifyContent="space-between"
						spacing={{ xs: 1, md: 3 }}
					>
						<Stack direction="row" alignItems="center">
							{slots?.button}
							{/* <MenuButton
								data-slot="menu-button"
								onClick={mobileNavOpen.onTrue}
								sx={{
									mr: 1,
									ml: -1,
									[theme.breakpoints.up(layoutQuery)]: {
										display: "none",
									},
								}}
							/> */}
							{slots?.leftArea ?? (
								<Logo
									height={smDown ? 30 : 35}
									width={smDown ? 70 : 100}
									href="/"
									component={Link}
								/>
							)}
						</Stack>
						<Box
							sx={{
								display: { xs: "none", sm: "flex" },
								flex: "1 1 auto",
								justifyContent: "left",
							}}
						>
							{slots?.centerArea}
						</Box>
						{slots?.rightArea ?? <HeaderRight />}
					</Stack>
				</Container>
			</Toolbar>
			{slots?.bottomArea}
		</AppBar>
	);
};

export default Header;
